import { useRef } from 'react';
import Layout from '@/components/feature/Layout';
import useDocumentMeta from '@/hooks/useDocumentMeta';
import FinalCta from '@/components/feature/FinalCta';
import useEditorialReveal from '@/hooks/useEditorialReveal';
import SplitHero from './components/SplitHero';
import Philosophy from './components/Philosophy';
import SelectedProjects from './components/SelectedProjects';
import SurfaceLibrary from './components/SurfaceLibrary';
import Expertise from './components/Expertise';
import Process from './components/Process';

export default function Home() {
  useDocumentMeta(
    'MATERA | Exterior Wall Finishing & Facade Restoration',
    'MATERA Exterior Surface Works: residential exterior wall restoration, stucco and render finishes, mineral and lime-based coatings, and surface protection by a craft-focused team.',
  );
  // Reveal scope starts below the Hero, so the Hero timeline is never touched.
  const below = useRef<HTMLDivElement>(null);
  useEditorialReveal(below);
  return (
    <Layout>
      <SplitHero />
      <div ref={below}>
        <Philosophy />
        <SelectedProjects />
        <SurfaceLibrary />
        <Expertise />
        <Process />
        <FinalCta />
      </div>
    </Layout>
  );
}